module.exports = __webpack_public_path__ + "static/media/handshake.fad588aa.svg";